import { observable, action } from 'mobx';

import Summary from './Summary';
import { post } from 'services/request';

export default class Store {
  steps = [];

  @observable offers;

  @observable message = '';

  summaryClass = Summary;

  constructor(management) {
    this.offers = management.source.offers.viewModel.offers.map((item) => {
      return {
        item,
        buyerId: item.buyerId,
        name: `${item.buyer.buyer_lastName}, ${item.buyer.buyer_firstName}`,
        submittedValue: item.submittedValue,
        validity: item.data ? item.data.offer_validity : null,
        status: item.status,
      };
    });
  }

  handleMessageChange = action((value) => {
    this.message = value;
  });

  @action async submit(saleId, token) {
    await post(
      `/api/v1/wizard/${saleId}/rejectall`,
      { message: this.message },
      token
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/Reject/index.js